import { render, staticRenderFns } from "./game_record.vue?vue&type=template&id=ae307d64&scoped=true&"
import script from "./game_record.vue?vue&type=script&lang=js&"
export * from "./game_record.vue?vue&type=script&lang=js&"
import style0 from "./game_record.vue?vue&type=style&index=0&id=ae307d64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae307d64",
  null
  
)

export default component.exports